import React, { FC, useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import axios from '../../../api/axios';
import { DealerAttributesChangeLog } from '../../../@types/ChangeLog';
import Modal from '../../common/Modal/Modal';
import { Divider, List, ListItem, ListItemText } from '@mui/material';
import moment from 'moment';


interface DealerAttributesChangelogModalProps {

  dealerId: string;

  closeModal: () => void;

  isVisible: boolean;

}

const DealerAttributesChangelogModal: FC<DealerAttributesChangelogModalProps> = ({ dealerId, closeModal, isVisible }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const [changelog, setChangelog] = useState<DealerAttributesChangeLog[]>([]);

  const fetchChangelog = useCallback(async () => {

    try {

      setLoading(true);

      const response = await axios.get('/dealer/meta-data/changelog', { params: { dealerId: dealerId } });

      if (response?.data?.data?.changelog) {

        console.log(response.data.data.changelog);

        setChangelog(response.data.data.changelog);

      }

    } catch (error) {

      toast.error(`Server error loading dealer attribute change log`);

    } finally {

      setLoading(false);

    }

  }, [dealerId, setLoading, setChangelog]);

  useEffect(() => {

    if (isVisible)

      fetchChangelog();

  }, [fetchChangelog, isVisible]);


  return (
    <>
      {isVisible &&
        <Modal title={`Attributes Changelog`} closeModal={closeModal}>
          <List
            sx={{
              padding: '0px 8px 0px 8px',
              overflowWrap: 'break-word',
              '.MuiListItem-root': {
                paddingLeft: 0,
                paddingRight: 0,
                '.MuiListItemText-root': {
                  lineHeight: '20px',
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                },
                '.MuiListItemText-root:first-of-type': {
                  marginRight: 12,
                },
                '.MuiListItemText-root:last-of-type': {
                  textAlign: 'right',
                }
              }
            }}>
            {changelog.length
              ? ((changelog.map((log: DealerAttributesChangeLog, index) => {
                const changedAttributes = log['attributes'];
                return (
                  <React.Fragment key={index}>
                    <ListItem>
                      <ListItemText>User</ListItemText>
                      <ListItemText>{log.user?.attributes.firstName} {log.user?.attributes?.lastName}</ListItemText>
                    </ListItem>
                    <ListItem>
                      <ListItemText>Date</ListItemText>
                      <ListItemText>{moment(new Date(log.date as string)).format('MM/DD/YYYY hh:mm:ss a')}</ListItemText>
                    </ListItem>
                    <ListItem>
                      <ListItemText>Changes:</ListItemText>
                      <ListItemText></ListItemText>
                    </ListItem>
                    {Object.entries(changedAttributes).map(([key, value]) => (
                      <ListItem key={key}>
                        <ListItemText>{key}</ListItemText>
                        <ListItemText>From: {value?.oldValue?.toString() ?? 'Missing'}, To: {value.newValue.toString()}</ListItemText>
                      </ListItem>
                    ))}
                    {/* Only render the divider if it's not the last item */}
                    {index < changelog.length - 1 && <Divider component="li" />}
                  </React.Fragment>
                )
              }
              )))
              : (<>No changes logged for dealer</>)
            }
          </List>
        </Modal>
      }
    </>
  );
}

export default DealerAttributesChangelogModal;
